import { chunk } from 'lodash';
const MAX_ITEM_LIMIT = 1000;

export const processChunk = async <Id extends string | number, T, R>(
    id: Id,
    added: T[],
    removed: T[],
    fetchCall: (id: Id, assignments: { added: T[]; removed: T[] }) => Promise<R>
): Promise<void> => {
    const addedChunked = chunk(added, MAX_ITEM_LIMIT);
    for (let i = 0; i < addedChunked.length; i++) {
        await fetchCall(id, {
            added: addedChunked[i],
            removed: [],
        });
    }

    const removedChunked = chunk(removed, MAX_ITEM_LIMIT);
    for (let i = 0; i < removedChunked.length; i++) {
        await fetchCall(id, {
            added: [],
            removed: removedChunked[i],
        });
    }
};
